import appConfig from 'app-config';
import AzarInduceRegisterModal from 'src/components/AzarOnly/InduceRegisterModal';
import VividiInduceRegisterModal from 'src/components/VividiOnly/InduceRegisterModal';
const InduceRegisterModal = (() => {
  if (appConfig.serviceCode === 'vividi') {
    return VividiInduceRegisterModal;
  }
  return AzarInduceRegisterModal;
})();
export default InduceRegisterModal;